<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF HOTEL MANAGEMENT & TOURISM</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">ABOUT US</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool01/14.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Hotel Management</h2>
                <p>The ARNI School of Hotel Management is a vibrant hub of aspiring hospitality professionals, combining
                    creativity, professionalism, and a global outlook. The way the hospitality industry growing rapidly,
                    the need for industry professionals has shot up drastically. The school is committed to producing
                    highly professionals with relevant skills, confidence, and adaptable nature that can excel in a
                    competitive environment. We pride ourselves on offering a dynamic learning environment that
                    integrates academic rigor with hands-on training. From culinary arts to front office management, and
                    event planning to luxury hospitality, our programs are designed to immerse students in every aspect
                    of the hospitality and tourism sectors.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision </b> - The goal is to establish a globally recognized center for hospitality education and
                    innovation, empowering students to lead and transform the hospitality industry through creativity,
                    excellence, and sustainability.
                </p>
                <p><b>Mission </b> – Our mission is to become a hub that offers a comprehensive program equipped with
                    theoretical and practical knowledge to students for diverse roles in the hospitality and tourism
                    industry.
                </p>

                <h2>Bachelor of Hotel Management and Science in Culinary Arts</h2>
                <p>The School of Hotel Management at ARNI University offers a diverse range of programs designed to meet
                    the dynamic needs of the global hospitality and tourism industry. With a perfect blend of
                    theoretical foundations and practical applications, our programs prepare students to excel in
                    various facets of hospitality, including hotel operations, culinary arts, tourism management, and
                    luxury services. Our industry-driven curriculum, delivered by experienced faculty and complemented
                    by state-of-the-art facilities, ensures that students are well-equipped with the knowledge, skills,
                    and confidence to succeed in a competitive market. The program covers all aspects of hotel
                    management and a bachelor of science in culinary management, including front office operations, food
                    and beverage services, housekeeping, and hospitality marketing. The hospitality management courses
                    are for aspiring chefs, focusing on the art of cooking, food presentation, and culinary innovation.
                </p>
                <p><b>Scope </b> - The Hotel Management Courses offers unparalleled opportunities for personal and
                    professional
                    growth in one of the world's fastest-growing industries. The course offers numerous options to
                    specialize in areas like culinary arts, hotel operations, tourism management, and more.
                </p>
                <ul>
                    <li> Graduates can pursue careers in hotels, resorts, cruise lines, airlines, event management, food
                        and beverage services, and luxury brands.
                    </li>
                    <li>Well-equipped training kitchens, mock reception areas, and housekeeping labs simulate real-world
                        hospitality scenarios.
                    </li>
                    <li> Partnerships with leading hospitality brands provide internships and on-the-job training in
                        real-world environments.
                    </li>
                </ul>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">4</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">8</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">5</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Hotel & Tourism</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BHMCT</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Science (Culinary Arts)</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Science (Hospitality & Culinary Management)</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Science (Hospitality & Hotel Administration)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
